var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-section',{attrs:{"collapsible":"","collapsed":"","help-collapsed":_vm.sectionHelp,"title":_vm.sectionTitle}},[_c('Details',{attrs:{"details":_vm.details}}),_c('TransactionSetting',{attrs:{"details":_vm.details}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }